<template>
    <div id="result-container" class="min-h-screen" v-bind:class="validation && size !== 'lg' ? 'bg-white' : 'bg-grey-bg'">
        <div v-if="this.validateComplete">
            <div v-if="validation">
                <div class="relative inline-block">
                    <div class="picture-gradient"></div>
                    <img class="align-middle lg:max-w-md" :src="`/img/backgrounds/img-confirmation${size === 'lg' ? '-big':''}.png`">
                </div>
                <div class="text-center px-8">
                    <p class="text-2xl font-light pb-4">{{ $t("purchase.ok.thanks") }}</p>
                    <p class="font-light text-grey-text">{{ $t("purchase.ok.mail") }}</p>
                    <ria-button class="block mx-auto my-5 uppercase" :text="i18n.t('review.ok')" :action="firstPage"/>
                </div>
            </div>
            <div class="h-screen" v-else>
                <div id="result-ko" class="text-center">
                    <img class="w-12 m-auto pb-3" src="/img/icons/icon-pay-error.svg">
                    <p class="text-grey-text font-light pb-4">{{ $t("purchase.ko.error") }}</p>
                    <ria-button class="block mx-auto my-5 uppercase bg-transparent" :text="i18n.t('purchase.ko.retry')" :action="cartPage" outline/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import RiaButton from "../components/common/ria-button";
import i18n from '../i18n';
import {keepScroll} from "../mixins";
export default {
    metaInfo() {
        return { 
            title: `${this.titleStatus} - ${this.resort.name}`,
            meta: [
                { name: 'description', content: this.descriptionStatus }, 
            ]
        }
    },
    mixins: [keepScroll],
    components: {
        RiaButton
    },
    data: function() {
      return {
          i18n: i18n,
          validateComplete: false,
          status: false,
          productGtagEcommerce:new Object()
      }
    },
    computed: {
        ...mapGetters("resort", ["resort", "currency"]),
        ...mapGetters("order", ["details","validate", "totalPricePromo", "totalTax"]),
        ...mapGetters("device", ["size"]),
        ...mapGetters('prices', ["productPrice","extraPrice","keycardPrice"]),
        validation: function(){
            return this.status || (this.validate && this.validate.status === 200)
        },
        titleStatus: function(){
            return this.validation ? this.$t('results.meta.title.ok') : this.$t('results.meta.title.ko')
        },
        descriptionStatus: function(){
            return this.validation ?  this.$t('results.meta.description.ok') : this.$t('results.meta.description.ko')
        },
    },
    async created(){
        if(this.$route.query.status) {
            this.status = this.$route.query.status.toLowerCase() === "ok";
        }else {
            await this.validateOrder(this.$route.query)
        }
        this.validateComplete = true;
       
        if(this.validation){
            this.$root.$emit('submitPurchase', this.sendTransaction())
        }
    },
    methods: {
        ...mapActions("order", ["validateOrder"]),
        firstPage: function(){
            this.$router.push({ name: 'Resorts' })
        },
        cartPage: function(){
            this.$router.push({ name: 'Cart' })
        },
        sendTransaction:function(){
            this.details.forEach(detail =>{
                //PRODUCTS
                this.addproductGtagEcommerce(`product_${detail.participant_id}`, 
                                            detail.participant_name, 
                                            this.productPrice(detail.date, detail.participant_id))
                
                //EXTRAS
                detail.extras.forEach(extra =>{
                    this.addproductGtagEcommerce(`extra_${extra.name}`,
                                                extra.name,
                                                this.extraPrice(extra, detail.participant_id))
                })
                
                //KEYCARD
                if(detail.keycard.new){
                    let keycard_price = this.keycardPrice(detail.date, detail.participant_id);
                    this.addproductGtagEcommerce('keycard', 'New keycard', keycard_price);  
                }
            })

            return {
                "transaction_id": this.$route.query.order_id,
                "affiliation": this.resort.name,
                "revenue": this.totalPricePromo,
                "currency": this.currency,
                "tax": this.totalTax,
                "items": Object.values(this.productGtagEcommerce)
            }; 
        },
        addproductGtagEcommerce(key,name,price){
            if(this.productGtagEcommerce[key] !== undefined){
                this.productGtagEcommerce[key].quantity++;
            }else{
                this.productGtagEcommerce[key] = {
                    'id':key,
                    'name':name,
                    'price':price,
                    'quantity':1
                };
            }
        }
    }
}
</script>
<style>
.picture-gradient {
    background: linear-gradient(
        to bottom, 
        rgba(255, 255, 255, 1) 0%, 
        rgba(228, 233, 234, 0) 20%, 
        rgba(228, 233, 234, 0) 80%, 
        rgba(255, 255, 255, 1) 100%
    ); 
    @apply absolute top-0 right-0 bottom-0 left-0;
}
#result-ko{
    top: 30%;
    @apply relative;
}
@screen lg {
    #result-container{
        @apply pt-0 pb-40 px-56;
    }
    .picture-gradient{
        background: none;
    }
}
</style>